import { useEffect, useState } from 'react';
import { Box, Divider, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import Iconify from '../../../components/iconify';
import Icons from '../Icons';

const Target = styled('label')(() => ({
  color: 'teal',
}));

export default function EmptyPublicChat() {
  const [icon, setIcon] = useState();

  function getRandomGreetingOrStartChatIcon() {
    const randomIndex = Math.floor(Math.random() * Icons.length);

    const selectedIcon = Icons[randomIndex];

    setIcon(selectedIcon);
  }

  useEffect(() => {
    getRandomGreetingOrStartChatIcon();
  }, []);

  return (
    <Box
      sx={{
        padding: { xs: 1, sm: 15 },
        paddingTop: { xs: 10 },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        transition: 'transform 0.5s ease',
        '&:hover': {
          transform: 'scale(1.05)',
        },
      }}
    >
      <Typography variant="subtitle1" sx={{ color: 'text.primary' }}>
        እንኳን ወደ <Target>ህዝባዊ</Target> የውይይት መድረክ በደህና መጡ!
      </Typography>
      <Typography variant="body3" sx={{ color: 'text.primary' }}>
        ይህ ህዝባዊ ውይይት ለሁሉም ይቀርባል!
      </Typography>
      <Typography sx={{ m: 2 }}>
        <Iconify sx={{ width: 20, height: 20 }} icon={icon} />
      </Typography>
      <Divider />
      <Typography variant="body1" sx={{ color: 'text.secondary' }}>
        አሁን ውይይት ይጀምሩ!
      </Typography>
    </Box>
  );
}
